import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRoutes, useLocation } from "react-router-dom";
import { apiAuthenticate, verifyApiToken } from './redux/features/appSlice';
import { routes } from './services/routes/routes';
import './styles/Entry.scss';

function App() {
  let element = useRoutes(routes);
  const location = useLocation();
  const apiToken = useSelector((state) => state.app.apiToken);

  const dispatch = useDispatch();
  useEffect(() => {
    if (apiToken === '') {
      const localApiToken = localStorage.getItem('apiToken', null);
      // check for localstorage
      if (localApiToken) {
        dispatch(verifyApiToken(localApiToken));
      } else {
        dispatch(apiAuthenticate());
      }
    } else {
      dispatch(verifyApiToken(apiToken));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const htmlElement = document.documentElement;
    if (location.pathname === "/login") {
      htmlElement.classList.add("no-zoom");
    } else {
      if (htmlElement.classList.contains("no-zoom")) {
        htmlElement.classList.remove("no-zoom");
      }
    }
  }, [location.pathname])
  return (
    <div className="App">
      {element}
    </div>
  );
}
export default App;
